/**
 * Показ отказа пользователю.
 *
 * Норма: spec/backend/invariants/api-errors.md, api-errors-R08 (отказ доходит до
 * пользователя) и api-errors-R09 (отказ не теряется молча).
 *
 * Composable эфемерный: держит только перевод и вывод сообщения, состояние
 * MVI не трогает.
 */

import { useI18n } from "vue-i18n";
import { ElMessage } from "element-plus";
import type { IApiError } from "@/shared/types";
import { resolveApiErrorText } from "./resolveApiErrorText";

export interface IApiErrorMessage {
  /** Текст отказа на языке интерфейса. */
  readonly apiErrorText: (error: IApiError | null | undefined) => string;
  /** Показать отказ пользователю. */
  readonly showApiError: (error: IApiError | null | undefined) => void;
}

/**
 * @param namespaces зональные пространства ключей переводов, в порядке приоритета
 *                   (например `["mapping"]` → `mapping.errors.<код причины>`).
 */
export function useApiErrorMessage(
  namespaces: readonly string[] = []
): IApiErrorMessage {
  const { t, te } = useI18n();

  function apiErrorText(error: IApiError | null | undefined): string {
    return resolveApiErrorText(
      error,
      (key, params) => (te(key) ? t(key, params) : undefined),
      namespaces
    );
  }

  function showApiError(error: IApiError | null | undefined): void {
    ElMessage.error(apiErrorText(error));
  }

  return { apiErrorText, showApiError };
}
